export const pusherPublicChannelName = 'public';
export const notifyAndFlyCreateEventName = 'notify-and-fly.create';
